// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHeaders_header__MYhij {
  font-size: 20px;
  font-weight: 700;
  line-height: 35px;
}
.tableHeaders_headerIcon__9aVGo {
  padding-inline-end: 8px;
}
.tableHeaders_container__D2F7m {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
.tableHeaders_endPart__5SXnX {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.tableHeaders_startPart__dgsEn {
  display: flex;
  align-items: center;
  column-gap: 6px;
}
.tableHeaders_tableFeatureIcon__Y9XPM {
  color: #272727;
  fill: #272727;
  cursor: pointer;
  transition: all 0.2s ease-out !important ;
}
.tableHeaders_tableFeatureIcon__Y9XPM:hover {
  color: #0e0e0e;
  fill: #0e0e0e;
  transform: scale(1.2);
}
.tableHeaders_addTableFeatureContainer__b-e7t {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0080ff;
  color: #fff;
  fill: #fff;
  border-radius: 7px;
  /* padding-inline-start: 12px;
  padding-inline-end: 18px; */
  padding-block: 4px;
  padding-inline: 37px;
}
.tableHeaders_addBtnTooltip__VI9V- {
  visibility: hidden;
  text-align: center;
  border-radius: 4px;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: var(--sidebar-background-color);
  color: #fff;
  opacity: 0;
  left: -7px;
  top: -48px;
  transition: all 0.4s ease-out;
}
.tableHeaders_addBtnTooltip__VI9V-::after {
  content: "";
  position: absolute;
  background-color: var(--sidebar-background-color);
  width: 20px;
  height: 20px;
  left: 10px;
  bottom: -15px;
  clip-path: polygon(50% 80%, 0 0, 100% 0);
}
.tableHeaders_addTableFeatureContainer__b-e7t:hover .tableHeaders_addBtnTooltip__VI9V- {
  visibility: visible;
  opacity: 1;
}
.tableHeaders_addTableFeatureIconContainer__0ZCAn,
.tableHeaders_addTableFeatureTxtContainer__9JF-C {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tableHeaders_addTableFeatureTxtContainer__9JF-C {
  transform: translateY(1px);
  font-size: 14px;
  font-weight: 700;
  line-height: 28px;
  padding-inline: 3px;
}
.tableHeaders_selectAllInput__QZR3v {
  width: 16px;
  height: 16px;
  margin-inline-start: 21px;
}

.tableHeaders_ColumnEditSpanContainer__2kZrH {
  position: absolute !important;
  background-color: #fff;
  padding: 4px 0;
  z-index: 21;
  top: 95px !important ;
  /* min-width: 180px; */
  margin-inline-start: 100px;
  border-radius: 4px;
  box-shadow:
    #0717391f 0px 0px 5px,
    #0717391f 0px 1px 5px;
  white-space: nowrap !important;
  scroll-behavior: smooth !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  max-height: 600px !important;
}
.tableHeaders_columnEditBackDrop__JrY\\+l {
  position: fixed;
  top: 0;
  background-color: transparent;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 20;
}
.tableHeaders_ColumnEditSpanContainer__2kZrH::-webkit-scrollbar {
  width: 8px;
  height: 180px !important;
}
.tableHeaders_ColumnEditSpanContainer__2kZrH::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px #8fa4c3;
  background-color: #fff;
}
.tableHeaders_ColumnEditSpanContainer__2kZrH::-webkit-scrollbar-thumb {
  background-color: #274684;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 100px;
}
.tableHeaders_scrollColumnEditSpanContainer__RmbEC {
  padding: 4px 0;
}
.tableHeaders_columnPersonlizer__yT93\\+ {
  color: #787878;
  padding-inline-start: 8px;
  font-size: 13px;
  padding-block: 6px 12px;
  border-bottom: 1px solid #bbc0ca;
}
.tableHeaders_columns__g1hfY {
  color: #787878;
  padding-inline-start: 8px;
  padding-block: 10px;
  font-size: 13px;
}
.tableHeaders_ColumnEditLine__IhFSY {
  padding-inline-start: 8px;
  padding-inline-end: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  column-gap: 8px;
  height: 38px !important;
}
.tableHeaders_ColumnEditLine__IhFSY label {
  cursor: pointer;
}
.tableHeaders_ColumnEditLine__IhFSY:hover {
  background-color: #c1e3ff;
}
.tableHeaders_ColumnEditLineCheckBox__QmUaV {
  appearance: none;
  position: relative;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 3px;
  border: 1px solid rgba(28, 57, 187, 0.486);
  cursor: pointer;
}
/* .ColumnEditLineCheckBox:checked {
  background-color: rgb(28, 57, 187);
  border: none;
}
.ColumnEditLineCheckBox:checked::before {
  content: "\\2713";
  font-family: Estedad !important;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  position: absolute;
  top: -4px;
  left: 2px;
} */
.tableHeaders_checkboxEditColumns__CTkZU {
  color: #787878;
  font-weight: 400;
  flex-grow: 1;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.tableHeaders_fullScreenIconContainer__QXsx9,
.tableHeaders_rowIconContainer__1sDCZ,
.tableHeaders_columnIconContainer__BdXS5,
.tableHeaders_searchIconContainer__JTT-e {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tableHeaders_tooltip__yxJiN {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.4s;
  z-index: 1;
  pointer-events: none; /* Prevent the tooltip from interfering with cursor */
  font-size: 12px;
}
.tableHeaders_fullScreenIconContainer__QXsx9:hover .tableHeaders_tooltip__yxJiN,
.tableHeaders_rowIconContainer__1sDCZ:hover .tableHeaders_tooltip__yxJiN,
.tableHeaders_columnIconContainer__BdXS5:hover .tableHeaders_tooltip__yxJiN,
.tableHeaders_searchIconContainer__JTT-e:hover .tableHeaders_tooltip__yxJiN {
  visibility: visible;
  opacity: 1;
}
.tableHeaders_tooltip__yxJiN::after {
  content: "";
  position: absolute;
  top: 100%; /* Position the arrow at the bottom of the tooltip */
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px; /* Size of the arrow */
  border-style: solid;
  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */
}

@media all and (max-width: 900px) {
  .tableHeaders_addTableFeatureContainer__b-e7t {
    padding-inline: 25px;
  }
}
@media all and (max-width: 600px) {
  .tableHeaders_container__D2F7m {
    align-items: flex-end;
    flex-direction: column;
    row-gap: 20px;
    direction: ltr;
  }
  .tableHeaders_endPart__5SXnX {
    align-self: flex-start;
    /* flex-direction: row-reverse; !!!!! THIS IS CAUSING THE HTML TAG TO SHIFT !!!!! */
    /* flex-grow: 1; */
  }
  .tableHeaders_addTableFeatureContainer__b-e7t {
    padding-inline: 37px;
  }
}
@media all and (max-width: 400px) {
  .tableHeaders_endPart__5SXnX {
    column-gap: 8px;
  }
  .tableHeaders_addTableFeatureContainer__b-e7t {
    padding-inline: 15px;
  }
}
/* @media all and (max-width: 600px) {
  .ColumnEditSpanContainer {
    min-width: 90%;
    width: 90%;
    right: 5%;
  }
} */

/* @media all and (max-width: 900px) {
  .container {
    padding-bottom: 2em !important;
  }
}
@media all and (max-width: 600px) {
  .container {
    padding-bottom: 1em !important;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableHeader/tableHeaders.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB;6BAC2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,iDAAiD;EACjD,WAAW;EACX,UAAU;EACV,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB;;yBAEuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,MAAM;EACN,6BAA6B;EAC7B,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;AACA;;;;;;;;;;;;;GAaG;AACH;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,UAAU;EACV,oBAAoB,EAAE,qDAAqD;EAC3E,eAAe;AACjB;AACA;;;;EAIE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,oDAAoD;EAC/D,SAAS;EACT,2BAA2B;EAC3B,iBAAiB,EAAE,sBAAsB;EACzC,mBAAmB;EACnB,sDAAsD,EAAE,yCAAyC;AACnG;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,mFAAmF;IACnF,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;;;;;;GAMG;;AAEH;;;;;;;;;GASG","sourcesContent":[".header {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  line-height: 35px;\r\n}\r\n.headerIcon {\r\n  padding-inline-end: 8px;\r\n}\r\n.container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 0 10px;\r\n}\r\n.endPart {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 16px;\r\n}\r\n.startPart {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 6px;\r\n}\r\n.tableFeatureIcon {\r\n  color: #272727;\r\n  fill: #272727;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-out !important ;\r\n}\r\n.tableFeatureIcon:hover {\r\n  color: #0e0e0e;\r\n  fill: #0e0e0e;\r\n  transform: scale(1.2);\r\n}\r\n.addTableFeatureContainer {\r\n  position: relative;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #0080ff;\r\n  color: #fff;\r\n  fill: #fff;\r\n  border-radius: 7px;\r\n  /* padding-inline-start: 12px;\r\n  padding-inline-end: 18px; */\r\n  padding-block: 4px;\r\n  padding-inline: 37px;\r\n}\r\n.addBtnTooltip {\r\n  visibility: hidden;\r\n  text-align: center;\r\n  border-radius: 4px;\r\n  padding: 5px 10px;\r\n  position: absolute;\r\n  z-index: 1;\r\n  background-color: var(--sidebar-background-color);\r\n  color: #fff;\r\n  opacity: 0;\r\n  left: -7px;\r\n  top: -48px;\r\n  transition: all 0.4s ease-out;\r\n}\r\n.addBtnTooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  background-color: var(--sidebar-background-color);\r\n  width: 20px;\r\n  height: 20px;\r\n  left: 10px;\r\n  bottom: -15px;\r\n  clip-path: polygon(50% 80%, 0 0, 100% 0);\r\n}\r\n.addTableFeatureContainer:hover .addBtnTooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.addTableFeatureIconContainer,\r\n.addTableFeatureTxtContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.addTableFeatureTxtContainer {\r\n  transform: translateY(1px);\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  line-height: 28px;\r\n  padding-inline: 3px;\r\n}\r\n.selectAllInput {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-inline-start: 21px;\r\n}\r\n\r\n.ColumnEditSpanContainer {\r\n  position: absolute !important;\r\n  background-color: #fff;\r\n  padding: 4px 0;\r\n  z-index: 21;\r\n  top: 95px !important ;\r\n  /* min-width: 180px; */\r\n  margin-inline-start: 100px;\r\n  border-radius: 4px;\r\n  box-shadow:\r\n    #0717391f 0px 0px 5px,\r\n    #0717391f 0px 1px 5px;\r\n  white-space: nowrap !important;\r\n  scroll-behavior: smooth !important;\r\n  overflow-y: auto !important;\r\n  -webkit-overflow-scrolling: touch !important;\r\n  max-height: 600px !important;\r\n}\r\n.columnEditBackDrop {\r\n  position: fixed;\r\n  top: 0;\r\n  background-color: transparent;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  z-index: 20;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 180px !important;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 6px #8fa4c3;\r\n  background-color: #fff;\r\n}\r\n.ColumnEditSpanContainer::-webkit-scrollbar-thumb {\r\n  background-color: #274684;\r\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 100px;\r\n}\r\n.scrollColumnEditSpanContainer {\r\n  padding: 4px 0;\r\n}\r\n.columnPersonlizer {\r\n  color: #787878;\r\n  padding-inline-start: 8px;\r\n  font-size: 13px;\r\n  padding-block: 6px 12px;\r\n  border-bottom: 1px solid #bbc0ca;\r\n}\r\n.columns {\r\n  color: #787878;\r\n  padding-inline-start: 8px;\r\n  padding-block: 10px;\r\n  font-size: 13px;\r\n}\r\n.ColumnEditLine {\r\n  padding-inline-start: 8px;\r\n  padding-inline-end: 26px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-direction: row-reverse;\r\n  column-gap: 8px;\r\n  height: 38px !important;\r\n}\r\n.ColumnEditLine label {\r\n  cursor: pointer;\r\n}\r\n.ColumnEditLine:hover {\r\n  background-color: #c1e3ff;\r\n}\r\n.ColumnEditLineCheckBox {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  position: relative;\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: #fff;\r\n  border-radius: 3px;\r\n  border: 1px solid rgba(28, 57, 187, 0.486);\r\n  cursor: pointer;\r\n}\r\n/* .ColumnEditLineCheckBox:checked {\r\n  background-color: rgb(28, 57, 187);\r\n  border: none;\r\n}\r\n.ColumnEditLineCheckBox:checked::before {\r\n  content: \"\\2713\";\r\n  font-family: Estedad !important;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  position: absolute;\r\n  top: -4px;\r\n  left: 2px;\r\n} */\r\n.checkboxEditColumns {\r\n  color: #787878;\r\n  font-weight: 400;\r\n  flex-grow: 1;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 13px;\r\n}\r\n.fullScreenIconContainer,\r\n.rowIconContainer,\r\n.columnIconContainer,\r\n.searchIconContainer {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.tooltip {\r\n  visibility: hidden;\r\n  background-color: #333;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 5px 10px;\r\n  border-radius: 4px;\r\n  position: absolute;\r\n  bottom: calc(100% + 10px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transition: opacity 0.4s;\r\n  z-index: 1;\r\n  pointer-events: none; /* Prevent the tooltip from interfering with cursor */\r\n  font-size: 12px;\r\n}\r\n.fullScreenIconContainer:hover .tooltip,\r\n.rowIconContainer:hover .tooltip,\r\n.columnIconContainer:hover .tooltip,\r\n.searchIconContainer:hover .tooltip {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%; /* Position the arrow at the bottom of the tooltip */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px; /* Size of the arrow */\r\n  border-style: solid;\r\n  border-color: #333 transparent transparent transparent; /* Triangle color and transparent sides */\r\n}\r\n\r\n@media all and (max-width: 900px) {\r\n  .addTableFeatureContainer {\r\n    padding-inline: 25px;\r\n  }\r\n}\r\n@media all and (max-width: 600px) {\r\n  .container {\r\n    align-items: flex-end;\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n    direction: ltr;\r\n  }\r\n  .endPart {\r\n    align-self: flex-start;\r\n    /* flex-direction: row-reverse; !!!!! THIS IS CAUSING THE HTML TAG TO SHIFT !!!!! */\r\n    /* flex-grow: 1; */\r\n  }\r\n  .addTableFeatureContainer {\r\n    padding-inline: 37px;\r\n  }\r\n}\r\n@media all and (max-width: 400px) {\r\n  .endPart {\r\n    column-gap: 8px;\r\n  }\r\n  .addTableFeatureContainer {\r\n    padding-inline: 15px;\r\n  }\r\n}\r\n/* @media all and (max-width: 600px) {\r\n  .ColumnEditSpanContainer {\r\n    min-width: 90%;\r\n    width: 90%;\r\n    right: 5%;\r\n  }\r\n} */\r\n\r\n/* @media all and (max-width: 900px) {\r\n  .container {\r\n    padding-bottom: 2em !important;\r\n  }\r\n}\r\n@media all and (max-width: 600px) {\r\n  .container {\r\n    padding-bottom: 1em !important;\r\n  }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `tableHeaders_header__MYhij`,
	"headerIcon": `tableHeaders_headerIcon__9aVGo`,
	"container": `tableHeaders_container__D2F7m`,
	"endPart": `tableHeaders_endPart__5SXnX`,
	"startPart": `tableHeaders_startPart__dgsEn`,
	"tableFeatureIcon": `tableHeaders_tableFeatureIcon__Y9XPM`,
	"addTableFeatureContainer": `tableHeaders_addTableFeatureContainer__b-e7t`,
	"addBtnTooltip": `tableHeaders_addBtnTooltip__VI9V-`,
	"addTableFeatureIconContainer": `tableHeaders_addTableFeatureIconContainer__0ZCAn`,
	"addTableFeatureTxtContainer": `tableHeaders_addTableFeatureTxtContainer__9JF-C`,
	"selectAllInput": `tableHeaders_selectAllInput__QZR3v`,
	"ColumnEditSpanContainer": `tableHeaders_ColumnEditSpanContainer__2kZrH`,
	"columnEditBackDrop": `tableHeaders_columnEditBackDrop__JrY+l`,
	"scrollColumnEditSpanContainer": `tableHeaders_scrollColumnEditSpanContainer__RmbEC`,
	"columnPersonlizer": `tableHeaders_columnPersonlizer__yT93+`,
	"columns": `tableHeaders_columns__g1hfY`,
	"ColumnEditLine": `tableHeaders_ColumnEditLine__IhFSY`,
	"ColumnEditLineCheckBox": `tableHeaders_ColumnEditLineCheckBox__QmUaV`,
	"checkboxEditColumns": `tableHeaders_checkboxEditColumns__CTkZU`,
	"fullScreenIconContainer": `tableHeaders_fullScreenIconContainer__QXsx9`,
	"rowIconContainer": `tableHeaders_rowIconContainer__1sDCZ`,
	"columnIconContainer": `tableHeaders_columnIconContainer__BdXS5`,
	"searchIconContainer": `tableHeaders_searchIconContainer__JTT-e`,
	"tooltip": `tableHeaders_tooltip__yxJiN`
};
export default ___CSS_LOADER_EXPORT___;
